import Swal from 'sweetalert2/src/sweetalert2.js';

/**
 * Error message replacement function to override ugly messages
 * @param {string} error Original error message from RCM
 * @returns {object} error object with updated values
 */
export const getErrorOverride = (error) => {

    // Search for the replacement error message if any exists
    let cmsError = window.errors.filter(item => error.toString().includes(item.error));

    // If there is a replacement error message return it
    if (cmsError && cmsError[0] !== undefined) {
        return { icon: cmsError[0].icon, title: cmsError[0].title, message: cmsError[0].override };
    } else {
        return { icon: 'info', title: 'Whoops!...', message: `<p>${(error !== '') ? error : 'Something went wrong, please refresh the page'}</p>` };
    }
};

/**
 * 
 * @param {string} error Original error message from RCM
 */
export const showError = (error) => {

    // Find the replacement error message if any exists
    let message = getErrorOverride(error);

    // Present the user with a modal with the error message
    new Swal({
        icon: message.icon,
        title: message.title,
        html: message.message
    });
};

